import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { OpenDialogAddTagComponent } from 'app/components/dialog/open-dialog-add-tag/open-dialog-add-tag.component';
import { Color } from 'app/shared/models/class/color/color';
import { Tag, TagType } from 'app/shared/models/class/tags/tag';
import { ColorService } from 'app/shared/services/color/color.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { TagService } from 'app/shared/services/tag/tag.service';

@Component({
  selector: 'app-admin-tags',
  templateUrl: './admin-tags.component.html',
  styleUrls: ['./admin-tags.component.scss']
})
export class AdminTagsComponent implements OnInit {

  searchForm: UntypedFormGroup;
  valueInput: string;

  tags: TagType[];
  color: ThemePalette = 'primary';
  categorySelected: TagType;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  displayedColumns: string[] = ['label', 'color', 'active', 'edit'];
  dataSource: MatTableDataSource<Tag>;

  length: number;
  pageSize = 50;
  // pageSizeOptions: number[] = [5, 10, 25, 50];
  pageSizeOptions: number[] = [50, 100, 150];
  pageEvent: PageEvent;

  updateColor = false;
  colors: Color[];

  constructor(
    private tagsService: TagService,
    private dialog: MatDialog,
    private formBuilder: UntypedFormBuilder,
    private colorService: ColorService,
    private faIconService: FaiconService,
  ) { }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  changeTagCategory(tagCategory: TagType): void {
    this.categorySelected = tagCategory;
    this.initTable(tagCategory.tags);
  }

  openDialogAddCategoryOrTag(type: string, title: string, action: string, tag?: Tag): void {
    const dialog = this.dialog.open(OpenDialogAddTagComponent, {
      data: { type, title, action, tagType: this.categorySelected, tag }
    });

    dialog.afterClosed().subscribe({
      next: () => this.getTags(true)
    });
  }

  applyFilter(filterValue): void {
    this.valueInput = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  resetSearch(): void {
    this.searchForm.get('keyword').setValue('');
    this.valueInput = '';
    this.applyFilter(this.valueInput);
  }

  updateColors(): void {
    this.updateColor = !this.updateColor;
  }

  changeActiveStatusCategory({ tagTypeKey }, { checked }): void {
    this.tagsService.updateTagTypeIsActive(tagTypeKey, checked).subscribe({
      next: () => this.getTags(true)
    });
  }

  changeActiveStatusTag({ tagKey }, { checked }): void {
    this.tagsService.updateTagIsActive(tagKey, checked).subscribe({
      next: () => this.getTags(true)
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.colors, event.previousIndex, event.currentIndex);

    this.colorService.updateOrderColor(this.colors).subscribe({
      next: () => { this.getColors(); }
    });
  }

  getTags(updateTag: boolean = false): void {
    this.tagsService.getTags().subscribe({
      next: tags => {

        const convertTag = [...tags];

        this.tags = convertTag.sort((a, b) => (b.isActive as any) - (a.isActive as any));

        if (!updateTag) { this.categorySelected = this.tags[0]; }
        else {
          this.categorySelected = tags.find(c => c.tagTypeKey === this.categorySelected.tagTypeKey);
        }

        this.initTable(this.categorySelected.tags);
      }
    });
  }

  private getColors(): void {
    this.colorService.getColors().subscribe({
      next: colors => {
        this.colors = colors.sort((a, b) => (a.order as any) - (b.order as any));
      }
    });
  }

  private initTable(tags: Tag[]): void {
    tags.sort((a, b) => (b.isActive as any) - (a.isActive as any));

    this.dataSource = new MatTableDataSource<Tag>(tags);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.length = tags.length;
  }

  private initComponent(): void {
    this.getTags();
    this.getColors();
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }
}
